import { Component, OnDestroy, OnInit } from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { EventStore } from '../../service/event.store';
import { ReservationCompareStore } from '../../service/reservation-compare-store';
import { MenuStore } from '../../../menus/service/menu.store';
import { PaymentStore } from '../../service/payment.store';
import { AuthenticationStore } from '../../../permission/services/authentication.store';
import { EventUtils } from '../../utils/event-utils';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { ReservationCompare } from '../../models/reservation-compare';
import { ReservationUtils } from '../../utils/reservation-utils';
import { SummaryRecordTypeEnum } from '../../models/summary-record-type.enum';
import { Subscription } from 'rxjs/Subscription';
import { PartyType } from '../../models/party-type';

@Component({
  selector: 'pioneer-vendor-reservation-page',
  templateUrl: './vendor-reservation-page.component.html',
  styleUrls: ['./vendor-reservation-page.component.css']
})
export class VendorReservationComponent implements OnInit, OnDestroy  {

  public onyxEvent: OnyxEvent;

  public headerRecordType: SummaryRecordTypeEnum;

  public total: string;

  eventSubscription$: Subscription = new Subscription();

  constructor(private eventStore: EventStore,
              private menuStore: MenuStore,
              private authenticationStore: AuthenticationStore) {
  }

  ngOnInit() {

    this.eventSubscription$ = this.eventStore.selectedEvent.subscribe((event: OnyxEvent) => {
      this.onyxEvent = new OnyxEvent(event);
      this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authenticationStore.isAgencyUser())
        , this.onyxEvent.eventProperty.subscriber);
    });

    this.headerRecordType = SummaryRecordTypeEnum.RESERVATION;
    this.total = 'total';

    this.checkMoreThanOneVendorExpanded();
  }

  ngOnDestroy() {
    this.eventSubscription$.unsubscribe();
  }

  getEventSubscriberProperties() {
    return this.onyxEvent.eventVendors
      .filter(vendor => vendor.partyType === PartyType.PROPERTY && vendor.payorType === 'PROPERTY' && vendor.subscriber);
  }

  showTotalSummary() {
    return this.getEventSubscriberProperties().length > 1;
  }

  private checkMoreThanOneVendorExpanded() {
    let expanded = false;

    this.getEventSubscriberProperties().forEach(function (party) {
      if (!expanded && party.isExpanded) {
        expanded = true;
      } else if (expanded) {
        party.isExpanded = false;
      }
    });
  }
}




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/vendor-reservation-page/vendor-reservation-page.component.ts